export const CHANGE_SEARCH_FIELD = 'CHANGE_SEARCH_FIELD';

export const REQUEST_ROBOTS_PENDING = 'REQUEST_ROBOTS_PENDING';
export const REQUEST_ROBOTS_SUCCES = 'REQUEST_ROBOTS_PENDING';
export const REQUEST_ROBOTS_FAIL = 'REQUEST_ROBOTS_PENDING';
